import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MotorQuote } from '../api/quote';
import { environment } from '../../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  private apiUrl = `${environment.apiUrl}/api/motor/quote`;

  constructor(private http: HttpClient) { }

  getMotorQuote(id: number): Observable<MotorQuote> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  postMotorQuote(formData: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, formData);
  }

  fetchAllCustomerQuotes(customerId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/find?customerId=${customerId}`);
  }

  fetchQuotesToPrint(quoteIds: number[]): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/fetch?quoteIds=${quoteIds}`)
  }

  fetchQuoteById(quoteId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${quoteId}`);
  }

  approveMotorQuote(quoteId: number, payload: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${quoteId}/approve`, payload);
  }

  postComprehensiveQuote(formData: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/comprehensive-motor/quote`, formData);
  }

  uploadVehicleImages(quoteId: number, formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/vehicle-image-upload?quoteId=${quoteId}`, formData, { responseType: 'text' });
  }

  approveComprehensiveQuote(quoteId: number, payload: any): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/api/comprehensive-motor/quote/${quoteId}/approve`, payload);
  }

  fetchComprehensiveQuoteById(quoteId: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/comprehensive-motor/${quoteId}`);
  }
}
